export const IconId = (props: IconClip) => {
	return (
		<svg
			width={props.width ?? 16}
			height={props.height ?? 16}
			viewBox="0 0 24 24"
			fill="none"
			stroke={props.color ?? "#d9dfe9"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<path d="M4 4h16v16H4z" />
			<path d="M9 9h1" />
			<path d="M14 9h1" />
			<path d="M9 15h6" />
		</svg>
	);
};
